/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [

    // Dashboard
    {
        id   : 'dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:rectangle-group',
        link : '/dashboard',
    },

    // Projects
    {
        id   : 'project-management.projects',
        title: 'Projects',
        type : 'basic',
        icon : 'mat_outline:bubble_chart',
        link : '/project-management/projects',
    },

    // CRM (Sales)
    {
        id      : 'crm',
        title   : 'Sales',
        type    : 'collapsable',
        icon    : 'custom:money',
        children: [

            // Sales Pipeline
            {
                id   : 'crm.pipeline',
                title: 'Sales Pipeline',
                type : 'basic',
                icon : 'heroicons_outline:presentation-chart-line',
                link : '/crm/pipeline',
            },

            // Lead Management
            {
                id   : 'crm.leads',
                title: 'Lead Management',
                type : 'basic',
                icon : 'feather:user',
                link : '/crm/leads',
            },

            // Contacts
            {
                id   : 'crm.contacts',
                title: 'Customers',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/crm/contacts',
            },

            // Sales Orders
            // {
            //     id   : 'crm.sales-orders',
            //     title: 'Sales Orders',
            //     type : 'basic',
            //     icon : 'mat_outline:shopping_cart',
            //     link : '/crm/sales-orders',
            // },

            // Email Marketing
            {
                id   : 'crm.emails',
                title: 'Emails',
                type : 'basic',
                icon : 'heroicons_outline:at-symbol',
                link : '/crm/emails',
            },

        ],
    },

    // Hire
    {
        id      : 'hire',
        title   : 'Hire',
        type    : 'collapsable',
        icon    : 'heroicons_outline:truck',
        children: [
            // Dashboard
            {
                id   : 'hire.dashboard',
                title: 'Hire Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-group',
                link : '/hire/dashboard',
            },
            // Dashboard
            {
                id   : 'hire.asset-board',
                title: 'Asset Board',
                type : 'basic',
                icon : 'heroicons_outline:view-columns',
                link : '/hire/asset-board',
            },
            // Customers
            // {
            //     id   : 'hire.customers',
            //     title: 'Customers',
            //     type : 'basic',
            //     icon : 'heroicons_outline:user-group',
            //     link : '/hire/customers',
            // },
            // Calendar
            {
                id   : 'hire.calendar',
                title: 'Calendar',
                type : 'basic',
                icon : 'heroicons_outline:calendar-days',
                link : '/hire/calendar',
            },
            // Assets
            {
                id   : 'hire.assets',
                title: 'Asset Register',
                type : 'basic',
                icon : 'heroicons_outline:cube-transparent',
                link : '/hire/assets',
            },
            // Hire Orders
            {
                id   : 'hire.hire-orders',
                title: 'Hire Orders',
                type : 'basic',
                icon : 'mat_outline:shopping_cart',
                link : '/hire/hire-orders',
            },
            // Invoicing
            {
                id   : 'hire.invoicing',
                title: 'Invoicing',
                type : 'basic',
                icon : 'heroicons_outline:document-text',
                link : '/hire/invoicing',
            },

            // Reporting
            {
                id   : 'crm.reporting',
                title: 'Reporting',
                type : 'basic',
                icon : 'feather:bar-chart-2',
                link : '/crm/reporting',
            },
        ],
    },

    // Calibrations
    {
        id      : 'calibration',
        title   : 'Calibration',
        type    : 'collapsable',
        icon    : 'heroicons_outline:wrench-screwdriver',
        children: [
            //     'My Dashboard'
            {
                id   : 'calibration.my-dashboard',
                title: 'My Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:rectangle-group',
                link : '/calibration/my-dashboard',
            },
            //     Admin Dashboard
            {
                id   : 'calibration.admin-dashboard',
                title: 'Admin Dashboard',
                type : 'basic',
                icon : 'heroicons_outline:squares-2x2',
                link : '/calibration/dashboard/admin-dashboard',
            },
            //     Engineer Dashboard
            {
                id   : 'calibration.engineer-dashboard',
                title: 'Engineer Dashboard',
                type : 'basic',
                icon : 'mat_outline:dashboard',
                link : '/calibration/dashboard/engineer-dashboard',
            },
            //     Workshop Dashboard
            {
                id   : 'calibration.workshop-dashboard',
                title: 'Workshop',
                type : 'basic',
                icon : 'mat_outline:home_repair_service',
                link : '/calibration/dashboard/workshop-dashboard',
            },
            //     Servicing
            {
                id   : 'calibration.servicing',
                title: 'Servicing',
                type : 'basic',
                icon : 'heroicons_outline:wrench',
                link : '/calibration/servicing',
            },
            //      Calibration Settings
            {
                id   : 'calibration.settings',
                title: 'Settings',
                type : 'basic',
                icon : 'heroicons_outline:cog-8-tooth',
                link : '/calibration/settings',
            },
        ],
    },

    //Inventory
    {
        id      : 'inventory',
        title   : 'Inventory',
        type    : 'collapsable',
        icon    : 'feather:clipboard',
        children: [
            //     Part Register
            {
                id   : 'part-register',
                title: 'Part Register',
                type : 'basic',
                icon : 'mat_outline:list_alt',
                link : '/part-register',
            },

            //     Product Register
            {
                id   : 'product-register',
                title: 'Product Register',
                type : 'basic',
                icon : 'heroicons_outline:clipboard-document-list',
                link : '/product-register',
            },

            //     Suppliers
            {
                id   : 'suppliers',
                title: 'Suppliers',
                type : 'basic',
                icon : 'custom:suppliers',
                link : '/suppliers',
            },

            //     Marine Part Register
            {
                id   : 'marine-part-register',
                title: 'Marine Parts',
                type : 'basic',
                icon : 'heroicons_outline:lifebuoy',
                link : '/marine-part-register',
            },
        ]
    },

    //Purchasing
    {
        id      : 'purchasing',
        title   : 'Purchasing',
        type    : 'collapsable',
        icon    : 'heroicons_outline:shopping-cart',
        children: [
            //     Purchase Orders
            {
                id   : 'purchase-orders',
                title: 'Purchase Orders',
                type : 'basic',
                icon : 'mat_outline:list_alt',
                link : '/purchase-orders',
            },
        ]
    },
    
    //     Sales Orders
    {
        id   : 'sales-orders',
        title: 'Sales Orders',
        type : 'basic',
        icon : 'mat_outline:list_alt',
        link : '/sales-orders',
    },

    //Admin
    {
        id      : 'admin',
        title   : 'Admin',
        type    : 'collapsable',
        icon    : 'heroicons_outline:identification',
        children: [

            //     HR
            {
                id   : 'hr',
                title: 'HR',
                type : 'basic',
                icon : 'heroicons_outline:user-group',
                link : '/hr',
            },

            //     Reports
            {
                id   : 'reports',
                title: 'Reports',
                type : 'basic',
                icon : 'mat_outline:insert_chart',
                link : '/reports',
            },

            //     Form Builder
            {
                id   : 'form-builder',
                title: 'Form Builder',
                type : 'basic',
                icon : 'mat_outline:build_circle',
                link : '/form-builder',
            },
        ],
    },

    //Production
    {
        id: 'production',
        title: 'Production',
        type: 'basic',
        icon: 'mat_outline:construction',
        link: '/production',
    },

    //     Clock In/Out
    {
        id   : 'calibration.clocking-in',
        title: 'Clock In/Out',
        type : 'basic',
        icon : 'custom:clock-in',
        link : '/calibration/clocking-in',
    },

    //     Help Center
    {
        id   : 'help-center',
        title: 'Help Center',
        type : 'basic',
        icon : 'heroicons_outline:question-mark-circle',
        link : '/help-center',
    },

    // Settings
    {
        id      : 'settings',
        title   : 'Settings',
        type    : 'basic',
        icon    : 'heroicons_outline:cog-8-tooth',
        link    : '/settings',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboard',
        title   : 'Dashboard',
        tooltip : 'Dashboard',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        tooltip : 'Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        tooltip : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'DASHBOARDS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'APPS',
        type    : 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id   : 'others',
        title: 'OTHERS',
        type : 'group',
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        type    : 'group',
        icon    : 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        type    : 'group',
        icon    : 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'group',
        icon    : 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
